import { render, staticRenderFns } from "./allinpay_unbind_phone.vue?vue&type=template&id=f2d66f70&scoped=true"
import script from "./allinpay_unbind_phone.vue?vue&type=script&lang=js"
export * from "./allinpay_unbind_phone.vue?vue&type=script&lang=js"
import style0 from "./allinpay_unbind_phone.vue?vue&type=style&index=0&id=f2d66f70&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d66f70",
  null
  
)

export default component.exports